import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectableObservable, Observable } from 'rxjs';
import { publishLast } from 'rxjs/operators';

import { withSpinner } from "../../extensions/withSpinner.extension";

import { Note } from "../../types";
import { API_ROOT } from "../../types/constants/appconstants";

@Injectable({
    "providedIn": "root"
})
export class NotesService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private notesBaseUrl = this.apiRoot + "api/notes";

    private lastGetScheduleTaskNotesId: number = null;
    private scheduleTaskNotes: ConnectableObservable<Note[]>;

    getScheduleTaskNotes(scheduleTaskId: number, forceReload: boolean = false): Observable<Note[]> {
        if (this.lastGetScheduleTaskNotesId === null || this.lastGetScheduleTaskNotesId !== scheduleTaskId || forceReload) {
            this.lastGetScheduleTaskNotesId = scheduleTaskId;

            this.scheduleTaskNotes = withSpinner(this.http).get<Note[]>(`${this.notesBaseUrl}/scheduletasks/${scheduleTaskId}/notes`).pipe(
                publishLast()
            ) as ConnectableObservable<Note[]>;
            this.scheduleTaskNotes.connect();
        }
        return this.scheduleTaskNotes;
    }

    createNote(id: number, note: Note, targetAudienceId: number, noteSubCategory: number, jobId?: number): Observable<Note> {
        if (jobId) {
            return withSpinner(this.http).post<Note>(`${this.notesBaseUrl}/${id}`, { "note": note, "targetAudienceId": targetAudienceId, "noteSubCategory": noteSubCategory, "jobId": jobId });
        } else {
            return withSpinner(this.http).post<Note>(`${this.notesBaseUrl}/${id}`, { "note": note, "targetAudienceId": targetAudienceId, "noteSubCategory": noteSubCategory });
        }
    }

    saveNote(id: number, note: Note, targetAudienceId: number, noteSubCategory: number): Observable<Note> {
        return withSpinner(this.http).put<Note>(`${this.notesBaseUrl}/${id}`, { "note": note, "targetAudienceId": targetAudienceId, noteSubCategory });
    }

    deleteNote(noteId: number): Observable<number> {
        return withSpinner(this.http).delete<number>(`${this.notesBaseUrl}/delete/${noteId}`);
    }
}